module.exports = __webpack_public_path__ + "static/JiraDashboard-eb26ef5f53614b7acc8819a8392afb3a.png";